/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Harness_NoteInputs */

const th_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุดทดสอบ ใช้วัดว่าวิดีโอสดทำงานอย่างไรบนโทรศัพท์และเครือข่ายจริง โดยรายงานทุกเซสชัน ไม่ใช่เฉพาะที่ล้มเหลว`)
};

const en_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A test harness. It measures how live video behaves on real phones and real networks — every session is reported, not just the ones that fail.`)
};

const ja_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト用の仕組みです。実際の端末と回線でライブ映像がどう動くかを計測し、失敗したものだけでなく全セッションを記録します。`)
};

const zh_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一套测试装置。它衡量实时视频在真实手机和真实网络上的表现——每一次会话都会上报，而不只是失败的那些。`)
};

const es_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un banco de pruebas. Mide cómo se comporta el vídeo en directo en móviles y redes reales: se informa de todas las sesiones, no solo de las que fallan.`)
};

const pt_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ambiente de teste. Ele mede como o vídeo ao vivo se comporta em celulares e redes reais — todas as sessões são reportadas, não só as que falham.`)
};

const id_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah alat uji. Ia mengukur perilaku video langsung di ponsel dan jaringan nyata — setiap sesi dilaporkan, bukan hanya yang gagal.`)
};

const fr_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un banc d’essai. Il mesure le comportement de la vidéo en direct sur de vrais téléphones et de vrais réseaux — toutes les sessions sont rapportées, pas seulement celles qui échouent.`)
};

const tl_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang panukat. Sinusukat nito ang asal ng live na video sa tunay na telepono at tunay na network — bawat sesyon ay iniuulat, hindi lang ang mga bigo.`)
};

const vi_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một bộ đo. Nó đo cách video trực tiếp hoạt động trên điện thoại thật và mạng thật — mọi phiên đều được báo cáo, không riêng phiên hỏng.`)
};

const ko_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`측정 장치입니다. 실제 휴대폰과 실제 네트워크에서 실시간 영상이 어떻게 동작하는지 재며, 실패한 세션만이 아니라 모든 세션을 보고합니다.`)
};

const de_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Prüfstand. Er misst, wie sich Live-Video auf echten Handys und echten Netzen verhält — jede Sitzung wird gemeldet, nicht nur die fehlgeschlagenen.`)
};

const ru_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это стенд. Он измеряет, как ведёт себя прямой эфир на настоящих телефонах и настоящих сетях — сообщается о каждой сессии, а не только о неудачных.`)
};

const tr_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir ölçüm düzeneği. Canlı görüntünün gerçek telefonlarda ve gerçek ağlarda nasıl davrandığını ölçer — yalnızca başarısız olanlar değil, her oturum raporlanır.`)
};

const it_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un banco di prova. Misura come si comporta il video in diretta su telefoni veri e reti vere: viene riportata ogni sessione, non solo quelle fallite.`)
};

const pl_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stanowisko pomiarowe. Mierzy, jak obraz na żywo zachowuje się na prawdziwych telefonach i prawdziwych sieciach — zgłaszana jest każda sesja, nie tylko nieudane.`)
};

const uk_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Це стенд. Він вимірює, як прямий ефір поводиться на справжніх телефонах і справжніх мережах — звітується про кожну сесію, а не лише про невдалі.`)
};

const hi_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह एक माप उपकरण है। यह मापता है कि असली फ़ोन और असली नेटवर्क पर लाइव वीडियो कैसा चलता है — हर सत्र की सूचना दी जाती है, केवल असफल सत्रों की नहीं।`)
};

const ar_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منصّة قياس. تقيس كيف يتصرّف البث المباشر على هواتف حقيقية وشبكات حقيقية — ويُبلَّغ عن كل جلسة، لا عن الفاشلة وحدها.`)
};

const ms_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah alat ujian. Ia mengukur kelakuan video langsung pada telefon sebenar dan rangkaian sebenar — setiap sesi dilaporkan, bukan yang gagal sahaja.`)
};

const bn_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি মাপার ব্যবস্থা। সত্যিকারের ফোন ও সত্যিকারের নেটওয়ার্কে সরাসরি ভিডিও কেমন চলে তা মাপে — প্রতিটি সেশনের কথা জানানো হয়, কেবল ব্যর্থগুলির নয়।`)
};

const zh_tw2_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是一套測試裝置。它衡量即時影片在真實手機與真實網路上的表現——每一次工作階段都會回報，而不只是失敗的那些。`)
};

const zh_hk2_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是一套測試裝置。它衡量即時短片在真實手機與真實網絡上的表現——每一次工作階段都會回報，而不只是失敗的那些。`)
};

const ur_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ ایک پیمائشی نظام ہے۔ یہ ناپتا ہے کہ اصل فون اور اصل نیٹ ورک پر براہ راست ویڈیو کیسی چلتی ہے — ہر سیشن کی اطلاع دی جاتی ہے، صرف ناکام کی نہیں۔`)
};

const fa_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یک سنجه. اندازه می‌گیرد که تصویر زنده روی گوشی‌های واقعی و شبکه‌های واقعی چگونه رفتار می‌کند — گزارش هر نشست داده می‌شود، نه فقط نشست‌های ناموفق.`)
};

const sw_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ni kifaa cha kupima. Hupima jinsi video ya moja kwa moja inavyofanya kazi kwenye simu halisi na mitandao halisi — kila kipindi huripotiwa, si vile vilivyoshindwa pekee.`)
};

const nl_video_harness_note = /** @type {(inputs: Video_Harness_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een meetopstelling. Hij meet hoe live video zich gedraagt op echte telefoons en echte netwerken — elke sessie wordt gemeld, niet alleen de mislukte.`)
};

/**
* | output |
* | --- |
* | "A test harness. It measures how live video behaves on real phones and real networks — every session is reported, not just the ones that fail." |
*
* @param {Video_Harness_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_harness_note = /** @type {((inputs?: Video_Harness_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Harness_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_harness_note(inputs)
	if (locale === "ja") return ja_video_harness_note(inputs)
	if (locale === "zh") return zh_video_harness_note(inputs)
	if (locale === "es") return es_video_harness_note(inputs)
	if (locale === "pt") return pt_video_harness_note(inputs)
	if (locale === "id") return id_video_harness_note(inputs)
	if (locale === "fr") return fr_video_harness_note(inputs)
	if (locale === "tl") return tl_video_harness_note(inputs)
	if (locale === "vi") return vi_video_harness_note(inputs)
	if (locale === "ko") return ko_video_harness_note(inputs)
	if (locale === "de") return de_video_harness_note(inputs)
	if (locale === "ru") return ru_video_harness_note(inputs)
	if (locale === "tr") return tr_video_harness_note(inputs)
	if (locale === "it") return it_video_harness_note(inputs)
	if (locale === "pl") return pl_video_harness_note(inputs)
	if (locale === "uk") return uk_video_harness_note(inputs)
	if (locale === "hi") return hi_video_harness_note(inputs)
	if (locale === "ar") return ar_video_harness_note(inputs)
	if (locale === "ms") return ms_video_harness_note(inputs)
	if (locale === "bn") return bn_video_harness_note(inputs)
	if (locale === "zh-TW") return zh_tw2_video_harness_note(inputs)
	if (locale === "zh-HK") return zh_hk2_video_harness_note(inputs)
	if (locale === "ur") return ur_video_harness_note(inputs)
	if (locale === "fa") return fa_video_harness_note(inputs)
	if (locale === "sw") return sw_video_harness_note(inputs)
	if (locale === "nl") return nl_video_harness_note(inputs)
	return en_video_harness_note(inputs)
});